import styles from './index.module.scss'
import {useQuery} from "react-query";
import jwtAxios from "../../../../auth/jwt-api";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
    Title
} from 'chart.js';
import {Pie, Bar} from 'react-chartjs-2';
import {Col, Row, Select, Spin} from "antd";
import {useIntl} from "react-intl";
import translate from "../../../../i18n/translate";
import {useSelector} from "react-redux";
import React, {useEffect, useState} from "react";

ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
    Title
);
const { Option } = Select;
const Dashboard = () => {
    const [propertyType, setPropertyType] = useState("apartment");

    const intl = useIntl();
    const {rate}=useSelector(state => state.rate)
    const { data:dataStatistics, isLoading:isLoadingStatistic } = useQuery(
        "apartment-statistics",
        () => jwtAxios.get("/apartment/statistics")
    );
    const { data:dataParkingStatistics, isLoading:isLoadinParkingStatistic,refetch:refetchParking } = useQuery(
        "parking-statistics",
        () => jwtAxios.get("/parking/statistics"),
        {
            enabled:true
        }
    );
    const { data:dataStorageStatistics, isLoading:isLoadinStorageStatistic,refetch:refetchStorage } = useQuery(
        "storage-statistics",
        () => jwtAxios.get("/storage-room/statistics"),
        {
            enabled:true
        }
    );
    const { data:dataRoomStatistics, isLoading:isLoadingRoomStatistic } = useQuery(
        "apartment-room-statistics",
        () => jwtAxios.get("/apartment/room-statistics")
    );


    useEffect(() => {
        if (propertyType==='parking'){
            refetchParking()
        }else if (propertyType==="storage-room"){
            refetchStorage()
        }
    }, [propertyType]);

    const statistics =propertyType==="parking" ?  dataParkingStatistics?.data?.data :propertyType==="storage-room" ? dataStorageStatistics?.data?.data : dataStatistics?.data?.data
    const roomStatistics = dataRoomStatistics?.data?.data?.roomStats;

    const pieM2Data = {
        labels: [
            intl.formatMessage({id: 'dashboard.sold_m2'}),
            intl.formatMessage({id: 'dashboard.unsold_m2'})
        ],
        datasets: [{
            data: [
                statistics?.sold?.m2 || 0,
                statistics?.unsold?.m2 || 0
            ],
            backgroundColor: ['#52c41a', '#ff4d4f'],
            borderColor: ['#52c41a', '#ff4d4f'],
            borderWidth: 1,
        }]
    };

    const pieMoneyData = {
        labels: [
            intl.formatMessage({id: 'dashboard.sold_sum'}),
            intl.formatMessage({id: 'dashboard.unsold_sum'})
        ],
        datasets: [{
            data: [
                statistics?.sold?.money || 0,
                statistics?.unsold?.money || 0
            ],
            backgroundColor: ['#1890ff', '#faad14'],
            borderColor: ['#1890ff', '#faad14'],
            borderWidth: 1,
        }]
    };

    const pieOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        const value = context.raw;
                        if (context.chart.canvas.id === 'money-chart') {
                            return `${context.label}: ${value.toLocaleString()} so'm`;
                        }
                        return `${context.label}: ${value.toLocaleString()} m²`;
                    }
                }
            }
        }
    };

    const roomOrder = [ '1+','2', '2+','3+','4'];
    const roomLabels = roomStatistics ? roomOrder.filter(key => key in roomStatistics) : [];
    const roomSuffix = intl.formatMessage({id: 'dashboard.room_suffix'});

    const barData = {
        labels: roomLabels.map(label => `${label} ${roomSuffix}`),
        datasets: [
            {
                label: intl.formatMessage({id: 'dashboard.sold'}),
                data: roomLabels.map(key => roomStatistics?.[key]?.sold || 0),
                backgroundColor: '#52c41a',
            },
            {
                label: intl.formatMessage({id: 'dashboard.unsold'}),
                data: roomLabels.map(key => roomStatistics?.[key]?.unsold || 0),
                backgroundColor: '#ff4d4f',
            }
        ]
    };

    const barOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: intl.formatMessage({id: 'dashboard.room_statistics_title'})
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 1
                }
            }
        }
    };

    if (isLoadingStatistic || isLoadingRoomStatistic) {
        return (
            <div className={styles.loading}>
                <Spin size="large" />
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>{intl.formatMessage({id: 'dashboard.title'})}</h2>
<Row>
    <Col offset={16} span={8}>
        <Select
            value={propertyType}
            style={{ width: '100%', marginBottom: 20 }}
            onChange={(value) => setPropertyType(value)}
        >
            <Option value="apartment">
                {translate("menu.apartments")}
            </Option>
            <Option value="parking">
                {translate("menu.parking")}
            </Option>
            <Option value="storage-room">
                {translate("menu.storage_room")}
            </Option>
        </Select>
    </Col>
</Row>
            <div className={styles.statsCards}>
                <div className={styles.card}>
                    <h4>{intl.formatMessage({id: 'dashboard.total_area'})}</h4>
                    <p>{statistics?.total?.m2?.toLocaleString()} m²</p>
                </div>
                <div className={styles.card}>
                    <h4>{intl.formatMessage({id: 'dashboard.total_amount'})}</h4>
                    <p>{(statistics?.total?.money*rate)?.toLocaleString()} {translate("dashboard.price.type")}</p>
                </div>
                <div className={styles.card}>
                    <h4>{intl.formatMessage({id: 'dashboard.sold_area'})}</h4>
                    <p>{statistics?.sold?.m2?.toLocaleString()} m²</p>
                </div>
                <div className={styles.card}>
                    <h4>{intl.formatMessage({id: 'dashboard.unsold_area'})}</h4>
                    <p>{statistics?.unsold?.m2?.toLocaleString()} m²</p>
                </div>
                <div className={styles.card}>
                    <h4>{intl.formatMessage({id: 'dashboard.sold_average'})}</h4>
                    <p>{(statistics?.average?.averagePriceSold*rate)?.toLocaleString()} {translate("dashboard.price.type")} </p>
                </div>
                <div className={styles.card}>
                    <h4>{intl.formatMessage({id: 'dashboard.unsold_average'})}</h4>
                    <p>{(statistics?.average?.averagePriceUnSold*rate)?.toLocaleString()} {translate("dashboard.price.type")}</p>
                </div>
            </div>

            <div className={styles.chartsRow}>
                <div className={styles.pieChart}>
                    <h3>{intl.formatMessage({id: 'dashboard.by_area'})}</h3>
                    <div className={styles.chartWrapper}>
                        <Pie data={pieM2Data} options={pieOptions}/>
                    </div>
                </div>
                <div className={styles.pieChart}>
                    <h3>{intl.formatMessage({id: 'dashboard.by_amount'})}</h3>
                    <div className={styles.chartWrapper}>
                        <Pie data={pieMoneyData} options={pieOptions} id="money-chart" />
                    </div>
                </div>
            </div>
            {
                propertyType==='apartment'
                &&
            <div className={styles.barChartSection}>
                <h3>{intl.formatMessage({id: 'dashboard.room_statistics'})}</h3>
                <div className={styles.barChartWrapper}>
                    <Bar data={barData} options={barOptions} />
                </div>
            </div>
            }
        </div>
    );
};

export default Dashboard;